import React from "react";

const OvertimeRadio = ({candiDetails,changeHandler,candiList}) => {
    // console.log({candiDetails,candiList,res:candiList?.candidateUniqueId?.indexOf(candiDetails?.candidateUniqueId)});
  return (
    <div>
      <p className="fw-bold m-0 b-0">Overtime Allowed</p>
      <div className="d-flex align-items-center">
        <div
          
          class="form-check p-4 m-0"
        >
          <input
          style={{cursor:'pointer'}}
          onChange={() =>changeHandler({radioName: "YES" ,candiID:candiDetails?.candidateUniqueId})}
            class="form-check-input"
            type="radio"
            name={`overtimeAllowedYes_${candiDetails?.candidateUniqueId}`}
            id={`overtimeAllowedYes_${candiDetails?.candidateUniqueId}`}
            // checked={candiList?.candidateUniqueId?.indexOf(candiDetails?.candidateUniqueId) > -1 ? true : false}
            checked={candiList?.find(candi => candi?.candidateUniqueId === candiDetails?.candidateUniqueId)?.allowOverwrite === true ? true : false }
          />
          <label style={{cursor:'pointer'}}  htmlFor={`overtimeAllowedYes_${candiDetails?.candidateUniqueId}`} class="form-check-label">Yes</label>
        </div>
        <div
          class="form-check  p-4 m-0"
        >
          <input
          style={{cursor:'pointer'}}
            onChange={() =>changeHandler({radioName: "NO" ,candiID:candiDetails?.candidateUniqueId})}
            class="form-check-input"
            type="radio"
            name={`overtimeAllowedNo_${candiDetails?.candidateUniqueId}_no`}
            id={`overtimeAllowedNo_${candiDetails?.candidateUniqueId}_no`}
            // checked={candiList?.candidateUniqueId?.indexOf(candiDetails?.candidateUniqueId) < 0 ? true : false}
            checked={candiList?.find(candi => candi?.candidateUniqueId === candiDetails?.candidateUniqueId)?.allowOverwrite === false ? true : false }
          />
          <label style={{cursor:'pointer'}} htmlFor={`overtimeAllowedNo_${candiDetails?.candidateUniqueId}_no`} class="form-check-label">No</label>
        </div>
      </div>
    </div>
  );
};

export default OvertimeRadio;
